import { useState, useEffect } from "react";
import CloseIcon from "../../../assets/crossIcon.svg";
import downIcon from "../../../assets/down-icon.svg";
import { CaseServices } from "../../../services/CaseServices";
import AddIcon from "../../../assets/addMoreIcon.svg";
import { CircularProgress } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import SuggestionBoxUtil from "../../../utils/SuggestionBoxUtil";
import { RpaServices } from "../../../services/RpaServices";
import { logOut } from "../../../config/user";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { ReactComponent as Plus } from "../../../assets/Plus.svg";
import QueryForwardDoctorModal from "../QueryForwardtoDoctorModal.jsx/QueryForwardDoctorModal";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
const EditStatusModal = ({
  setEditStatus,
  caseId,
  queryIds,
  AllCases,
  documents,
  latestStageSelectedDocs,
  selectedDocuments,
  setSelectedDocuments,
  latestStage,
  fetchQueries,
  fetchCaseQueryCounts,
  getLatestCaseStage,
}) => {
  const [documentStatus, setDocumentStatus] = useState(null);
  // const [rejectionReason, setRejectionReason] = useState(null);
  const [comment, setComment] = useState("");
  const [mappedDocuments, setMappedDocuments] = useState([]);
  const [inputValue, setInputValue] = useState(null);
  const [selectedMapping, setSelectedMapping] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rejectedCount, setRejectedCount] = useState(false);
  const [suggestionResetKey, setSuggestionResetKey] = useState(0);
  const currentRole = useSelector((state) => state.currentRole.value);
  const [openForwardDoctorModal, setOpenForwardDoctorModal] = useState(false);
  const [latestStageDocuments, setLatestStageDocuments] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const flatDocuments = documents?.flatMap((doc) => doc?.value || []) || [];

  useEffect(() => {
    if (flatDocuments.length > 0) {
      let formatted = flatDocuments.map((doc) => ({
        documentId: doc.id,
        status: true,
      }));
      setDocumentStatus(formatted);
    }
  }, [documents]);

  const handleCheckBoxChange = (documentId) => {
    const formattedDocument = documentStatus.map((document) => {
      if (document.documentId === documentId) {
        return {
          documentId: document.documentId,
          status: !document.status,
        };
      } else {
        return document;
      }
    });
    const postData = formattedDocument.filter((document) => !document.status);
    setRejectedCount(postData.length);
    setDocumentStatus(formattedDocument);
  };

  const handleAutoSuggestion = (selected, e) => {
    const docType = flatDocuments?.[0]?.documentType || "";

    setSelectedMapping({
      ...selected,
      documentType: docType,
    });
  };

  const handleMappedDocuments = async () => {
    const currentDocType = latestStage?.documents?.[0]?.documentType;
    const isEnhancementStage = latestStage?.currnetSubMasterStage?.[0]?.hsaStage
      ?.toLowerCase()
      ?.includes("enhancement");
    // 🚫 Nothing selected
    if (!selectedMapping && !inputValue) {
      toast.error("Please select at least one document");
      return;
    }

    // 🔁 Helper to prevent duplicates
    const isAlreadyMapped = (docName) =>
      mappedDocuments?.some((d) => d.documentName === docName);

    // =============================
    // 🟢 CASE 1: Manual Input
    // =============================
    if (inputValue) {
      if (!isAlreadyMapped(inputValue)) {
        const documentDetails = {
          caseStatge: "",
          documentType: currentDocType,
          documentName: inputValue,
          required: true,
        };

        setMappedDocuments((prev) => [...prev, documentDetails]);
        const payload = [
          {
            caseId,
            documentType: currentDocType,
            documentName: inputValue,
            ...(isEnhancementStage && {
              enhancementId: latestStage?.documents?.[0]?.enhancementId,
            }),
            status: "PENDING",
            required: false,
          },
        ];

        try {
          const res = await CaseServices.mapSaveQueryDocuments({
            documents: payload,
          });
          await getLatestCaseStage();
        } catch (error) {
          handleApiErrorResponses(error);
        }
      }

      setInputValue(null);
      setSelectedMapping(null);
      setSuggestionResetKey((prev) => prev + 1);
    }

    // =============================
    // 🟢 CASE 2: SuggestionBox (NEW DOC)
    // =============================
    if (selectedMapping) {
      if (!isAlreadyMapped(selectedMapping.documentName)) {
        setMappedDocuments((prev) => [...prev, selectedMapping]);
        const payload = [
          {
            caseId,
            documentType: currentDocType,
            documentName: selectedMapping.documentName,
            ...(isEnhancementStage && {
              enhancementId: latestStage?.documents?.[0]?.enhancementId,
            }),
            status: "PENDING",
            required: false,
          },
        ];

        try {
          const res = await CaseServices.mapSaveQueryDocuments({
            documents: payload,
          });
          await getLatestCaseStage();
        } catch (error) {
          handleApiErrorResponses(error);
        }
      }

      setSelectedMapping(null);
      setInputValue(null);
      setSuggestionResetKey((prev) => prev + 1);
    }
  };

  const suggestionStyles = {
    control: (base) => ({
      ...base,
      minHeight: "68px",
      height: "68px",
      borderRadius: "100px",
      borderWidth: "2px",
      borderStyle: "solid",
      borderColor: "rgba(232, 232, 232, 0.6)",
      paddingLeft: "16px",
      paddingRight: "16px",
      boxShadow: "none",
      display: "flex",
      alignItems: "center",
    }),

    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
    }),

    indicatorsContainer: (base) => ({
      ...base,
      paddingRight: "8px",
    }),

    placeholder: (base) => ({
      ...base,
      color: "#9CA3AF",
      fontFamily: "Lufga",
      fontSize: "14px",
    }),
  };

  const handleRemoveDocument = async (index, docName) => {
    try {
      const doc = latestStage?.documents?.find(
        (item) => item.documentName == docName,
      );
      if (!doc) return;
      const res = await CaseServices?.deleteDocument(doc?.id, true);
      toast.success(res?.data?.message);
      let changedArray = mappedDocuments.filter((_, idx) => idx !== index);
      setMappedDocuments(changedArray);
      setSuggestionResetKey((prev) => prev + 1);
      await getLatestCaseStage();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleForwardToTMS = async () => {
    if (!queryIds?.length) {
      toast.error("No query found to forward.");
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        queryId: queryIds[queryIds.length - 1],
      };
      const res = await RpaServices?.markQueryReadyForTms(payload);
      toast.success(res?.data?.message);

      // ✅ Cleanup
      setMappedDocuments([]);
      setSelectedDocuments([]);
      if (fetchQueries) {
        await fetchQueries();
      }
      if (fetchCaseQueryCounts) {
        await fetchCaseQueryCounts();
      }

      if (AllCases) {
        await AllCases();
      }
      navigate("/dashboard/ActiveCases");
      setEditStatus(null);
    } catch (error) {
      console.error("❌ API Error:", error);
      handleApiErrorResponses(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleForwardToHSA = async () => {
    if (!queryIds?.length) {
      toast.error("No query found to forward.");
      return;
    }

    if (latestStageSelectedDocs?.length > 0 && !comment) {
      toast.error("Suggestion is required for rejecting the document");
      return;
    }

    // if (!latestStageSelectedDocs?.length) {
    //   toast.error("Select a document to reject.");
    //   return;
    // }
    setIsSubmitting(true);

    try {
      const isEnhancementStage =
        latestStage?.currnetSubMasterStage?.[0]?.hsaStage
          ?.toLowerCase()
          ?.includes("enhancement");
      let mappedDocumentsCopy = [];
      if (latestStageSelectedDocs?.length > 0) {
        const existingDocsMapped = latestStageSelectedDocs.map((doc) => ({
          documentName: doc.documentName,
          documentType: doc.documentType,
          caseId: doc.caseId,
          enhancementId: doc.enhancementId,
          // documenturlmasters: doc.documenturlmasters ||
          isExisting: true,
          status: doc.status,
        }));

        if (existingDocsMapped.length > 0) {
          mappedDocumentsCopy = [...existingDocsMapped];
        }
      }
      const docs = mappedDocumentsCopy.map((d) => {
        const basePayload = {
          caseId: caseId,
          documentType: latestStage?.documents?.[0]?.documentType,
          documentName: d?.documentName,
        };

        // 🔥 EXISTING DOCUMENT
        if (d?.isExisting) {
          return {
            ...basePayload,
            ...(isEnhancementStage && {
              enhancementId: latestStage?.documents?.[0]?.enhancementId,
            }),
            status: d?.status === "PENDING" ? "PENDING" : "REJECTED",
            rejectionReason: d?.status === "PENDING" ? null : comment,
            completeDocRejected: d?.status === "PENDING" ? false : true,
          };
        }

        // 🆕 NEW DOCUMENT
        return {
          ...basePayload,
          ...(isEnhancementStage && {
            enhancementId: latestStage?.documents?.[0]?.enhancementId,
          }),
        };
      });

      const res = await RpaServices.forwardCaseQueryToHsa({
        queryId: queryIds[queryIds.length - 1],
        forwardedToIds: [],
        comment: comment,
        reforward: true,
        isNewDocMapped: latestStageSelectedDocs?.length > 0 ? true : false,
        documents: docs,
      });
      toast.success(res?.data?.message);
      if (fetchQueries) {
        await fetchQueries();
      }
      if (fetchCaseQueryCounts) {
        await fetchCaseQueryCounts();
      }
      if (AllCases) await AllCases();
      navigate("/dashboard/ActiveCases");
      setEditStatus(null);
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "40vh",
        overflowY: "auto",
        background: "white",
        borderRadius: "16px",
        padding: "16px",
      }}
      className="w-full"
    >
      <div className="w-full flex flex-col items-center">
        <div className="mt-4 w-full">
          <div className="w-full py-4 xl:p-4 ">
            <div className="flex justify-between items-center mb-4">
              <div className="text-xl text-[#191919] font-semibold">
                Map New Documents
              </div>

              <div
                className=" xl:w-fit flex items-center justify-center gap-2 text-sm bg-[#017C57] rounded-full px-4 py-3 text-white cursor-pointer"
                onClick={handleMappedDocuments}
              >
                <Plus className="w-5 h-5" />
                Map Documents
              </div>
            </div>

            <SuggestionBoxUtil
              api={CaseServices.defaultDocumentForSuggestionBox}
              handleChange={handleAutoSuggestion}
              name="documentName"
              setInputValue={setInputValue}
              resetKey={suggestionResetKey}
              styles={suggestionStyles}
            />

            {mappedDocuments.map((doc, idx) => (
              <div key={idx} className="flex justify-between mt-[8px]">
                <div className="w-[65%] border p-2 font-[Lufga] font-medium text-[12px] xl:text-[16px] 2xl:text-[16px] leading-[100%] tracking-[0em] text-[#191919]">
                  {idx + 1}. {doc?.documentName}
                </div>
                <div
                  onClick={() => handleRemoveDocument(idx, doc?.documentName)}
                >
                  <DeleteIcon style={{ color: "red" }} />
                </div>
              </div>
            ))}
          </div>

          {latestStageSelectedDocs?.length > 0 && (
            <textarea
              className="w-full h-[72px] border-2 border-solid border-[rgba(232,232,232,0.6)] rounded-[50px] p-[24px] font-[Lufga] text-[14px] text-[#1B1B1B] outline-none resize-none"
              placeholder="Suggestion"
              onChange={(e) => setComment(e.target.value)}
            />
          )}

          {(mappedDocuments?.length > 0 ||
            selectedDocuments?.length > 0 ||
            latestStageSelectedDocs?.length > 0) && (
            <div className="flex justify-center gap-6 mt-4">
              {!location.pathname?.includes("doctor") && (
                <div
                  className="bg-[#017C57] text-white px-6 py-3 rounded-full cursor-pointer"
                  onClick={() => setOpenForwardDoctorModal(true)}
                >
                  Forward To Doctor
                </div>
              )}

              <div
                className="bg-[#017C57] text-white px-6 py-3 rounded-full cursor-pointer"
                onClick={handleForwardToHSA}
              >
                Forward To HSA
              </div>

              {!latestStageSelectedDocs?.some(
                (doc) => doc.status === "PENDING",
              ) && (
                <div
                  className="bg-[#017C57] text-white px-6 py-3 rounded-full cursor-pointer"
                  onClick={handleForwardToTMS}
                >
                  Submit On TMS
                </div>
              )}
            </div>
          )}

          <QueryForwardDoctorModal
            open={openForwardDoctorModal}
            onClose={() => {
              setOpenForwardDoctorModal(false);
              setEditStatus(null);
            }}
            queryId={queryIds?.[0]}
            mappedDocuments={mappedDocuments}
            caseId={caseId}
            fetchQueries={fetchQueries}
            fetchCaseQueryCounts={fetchCaseQueryCounts}
          />
        </div>
      </div>
    </div>
  );
};

export default EditStatusModal;
